import type { ClientOptions } from "@/.generated/hey/backoffice-backend/types.gen";
import type { TBackofficeEnv } from "@/api/api-utils";

import { createClient, createConfig } from "@/.generated/hey/backoffice-backend/client";
import { reauthenticateOnSessionExpired } from "@/api/api-utils";
import { retrieveTokenDetailsFromLocalStorage } from "@/lib/helpers/authentication-helper";

interface BackofficeHeaders {
  serviceId: number;
  "X-Voltalis-ServiceId": number;
}

export function _makeSdkClient(env: TBackofficeEnv) {
  const serviceId = env.VITE_VOLTACALL_SERVICE_ID;
  const headers = {
    serviceId,
    "X-Voltalis-ServiceId": serviceId,
  } satisfies BackofficeHeaders;

  const client = createClient(
    createConfig<ClientOptions>({
      baseUrl: env.VITE_BACKOFFICE_BASE_URL,
      headers,
    }),
  );

  client.interceptors.request.use(authorizeRequest);
  client.interceptors.response.use((response, request) => reauthenticateOnSessionExpired(response, request, env));

  return { client, headers };
}

// Authentication

function authorizeRequest(request: Request): Request {
  const tokenDetails = retrieveTokenDetailsFromLocalStorage();
  if (!tokenDetails) {
    return request;
  }

  request.headers.append("Authorization", `Bearer ${tokenDetails.access_token}`);

  return request;
}
